import { render } from "./LineSeparator.vue?vue&type=template&id=f58f9da8&scoped=true"
const script = {}

import "./LineSeparator.vue?vue&type=style&index=0&id=f58f9da8&scoped=true&lang=css"

import exportComponent from "E:\\A\\Git\\Kea\\GeneralMarketing2022\\src\\GM.Shop2022\\Areas\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f58f9da8"]])

export default __exports__